const turf = require('@turf/helpers')
const {
  getUserPartner
} = require('fleetmap-partners')
const messages = require('../../lang')
const axios = require('axios').default
const distance = require('@turf/distance')
const { devicesToProcess } = require('./device')

exports.getTranslations = (userData) => {
  const lang = this.getLanguage(userData)
  if (!messages[lang]) {
    console.warn('no lang found for', userData.user, userData.user.attributes.lang)
  }
  return messages[lang] ? messages[lang] : messages['en-GB']
}

exports.getLanguage = (userData) => {
  return userData.user.attributes.lang ||
    ((typeof navigator !== 'undefined') && navigator.language) ||
    getUserPartner(userData.user).lang ||
    'pt-BR'
}

function convertMS (duration, withSeconds) {
  if (!duration || duration < 0) {
    return withSeconds ? '00:00:00' : '00:00'
  }

  const ms = duration % 1000
  let s = (duration - ms) / 1000
  let seconds = s % 60
  s = (s - seconds) / 60
  let minutes = s % 60
  let hours = (s - minutes) / 60

  hours = (hours < 10) ? '0' + hours : hours
  minutes = (minutes < 10) ? '0' + minutes : minutes
  seconds = (seconds < 10) ? '0' + seconds : seconds

  return withSeconds ? hours + ':' + minutes + ':' + seconds : hours + ':' + minutes
}

exports.formatNumber = function formatNumber (value) {
  return Number(value.toFixed(1))
}

function coordsDistance (lon1, lat1, lon2, lat2) {
  const from = turf.point([lon1, lat1])
  const to = turf.point([lon2, lat2])

  return distance.default(from, to, { units: 'meters' })
}

function convertPositionToFeature (position) {
  const point = turf.point([position.longitude, position.latitude])
  point.properties.position = position
  return point
}

function convertToFeature (geofence) {
  if (geofence.area.startsWith('POLYGON')) {
    const feature = {
      type: 'Feature',
      properties: {
        geofence
      },
      geometry: {
        type: 'Polygon',
        coordinates: [[]]
      }
    }
    const str = geofence.area.substring('POLYGON(('.length, geofence.area.length - 2)
    const coordList = str.split(',')
    for (const i in coordList) {
      const coord = coordList[i].trim().split(' ')
      feature.geometry.coordinates[0].push([parseFloat(coord[1]), parseFloat(coord[0])])
    }
    return feature
  }

  if (geofence.area.startsWith('CIRCLE')) {
    const str = geofence.area.substring('CIRCLE ('.length, geofence.area.length - 1)
    const coordList = str.split(',')
    const coord = coordList[0].trim().split(' ')
    const point = turf.point([parseFloat(coord[1]), parseFloat(coord[0])])
    point.properties.geofence = geofence
    point.properties.distance = coordList[1].trim()
    return point
  }

  if (geofence.area.startsWith('LINESTRING')) {
    const str = geofence.area.substring('LINESTRING ('.length, geofence.area.length - 1)
    const coordList = str.split(',')
    const coordinates = coordList.map(c => {
      const coord = c.trim().split(' ')
      return [parseFloat(coord[1]), parseFloat(coord[0])]
    })
    return {
      type: 'Feature',
      properties: {
        geofence
      },
      geometry: {
        type: 'LineString',
        coordinates
      }
    }
  }
}

function getDates (startDate, endDate, timezone) {
  const dates = []
  let currentDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 12, 0, 0, 0)
  const _endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 0)

  if (!isClientSide() && timezone) {
    const startDateUserTimezone = convertFromUTC(startDate, timezone)
    currentDate = new Date(startDateUserTimezone.getFullYear(), startDateUserTimezone.getMonth(), startDateUserTimezone.getDate(), 12, 0, 0, 0)
  }
  const addDays = function (days) {
    const date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  while (currentDate <= _endDate) {
    dates.push(currentDate)
    currentDate = addDays.call(currentDate, 1)
  }
  return dates
}

function getImage (url) {
  return require('axios').default.get(url, { responseType: 'arraybuffer' }).then(d => d.data)
}

async function getImageBase64 (url) {
  const response = await getImage(url)
  return Buffer.from(response, 'binary').toString('base64')
}

function getLogoUrl (hostname) {
  const path = `/img/logos/${hostname}.png`
  return isClientSide() ? path : `https://${hostname}${path}`
}

async function getImgFromUrl (hostname) {
  const url = getLogoUrl(hostname)
  try {
    const img = new Image()
    img.src = url
    return img
  } catch (e) {
    return await getImageBase64(url)
  }
}

function isClientSide () { return (typeof window !== 'undefined') }

function convertToLocaleString (value, lang, timezone, user) {
  if (isClientSide()) {
    return new Date(value).toLocaleString()
  }
  if ((lang && timezone) || user) {
    return new Date(value).toLocaleString(lang || getUserPartner(user).lang, {
      timeZone: timezone || getUserPartner(user).timezone,
      hour12: false
    })
  }
  return new Date(value).toISOString()
}

function convertToLocaleDateString (value, lang, timezone, user) {
  if (isClientSide()) {
    return new Date(value).toLocaleDateString()
  } else {
    return new Date(value).toLocaleDateString(lang || getUserPartner(user).lang, {
      timeZone: timezone || getUserPartner(user).timezone,
      hour12: false
    })
  }
}

function convertToLocaleTimeString (value, lang, timezone, user) {
  if (isClientSide()) {
    return new Date(value).toLocaleTimeString()
  } else {
    return new Date(value).toLocaleTimeString(lang || getUserPartner(user).lang, {
      timeZone: timezone || getUserPartner(user).timezone,
      hour12: false
    })
  }
}

function getTimezoneOffset (timezone) {
  if (isClientSide()) {
    return new Date().getTimezoneOffset()
  } else {
    const utcDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'UTC' }))
    const tzDate = new Date(new Date().toLocaleString('en-US', { timeZone: timezone }))
    return (utcDate.getTime() - tzDate.getTime()) / 6e4
  }
}

function convertFromUTC (value, timezone) {
  if (isClientSide()) {
    return new Date(value)
  }

  const offset = getTimezoneOffset(timezone)
  const valueDate = new Date(value)
  valueDate.setTime(valueDate.getTime() - (offset * 60 * 1000))
  return valueDate
}

exports.convertFromLocal = (value, timezone) => {
  const offset = getTimezoneOffset(timezone)

  const valueDate = new Date(value)
  valueDate.setTime(valueDate.getTime() + (offset * 60 * 1000))
  return valueDate
}

function weekDaySelected (date, weekDays) {
  return !weekDays || ((date.getDay() === 0 && weekDays.sunday) ||
    (date.getDay() === 1 && weekDays.monday) ||
    (date.getDay() === 2 && weekDays.tuesday) ||
    (date.getDay() === 3 && weekDays.wednesday) ||
    (date.getDay() === 4 && weekDays.thursday) ||
    (date.getDay() === 5 && weekDays.friday) ||
    (date.getDay() === 6 && weekDays.saturday))
}

async function executeServerSide (type, sliced, from, to, userData, totalItems, traccar, maxRequests = 10) {
  let itemsCount = 0
  console.log('PROGRESS_PERC:1')
  const cookie = await axios.get('/pinmeapi/cookie/get', { withCredentials: true }).then(d => d.data)
  const reportData = []
  for (let i = 0; i < sliced.length; i += maxRequests) {
    const _sliced = sliced.slice(i, i + maxRequests)
    await Promise.all(_sliced.map(async items => {
      const url = `https://${getServerHost()}/pinmeapi/reports/${type}`
      try {
        await axios.post(url, {
          from,
          to,
          userData: userData.byDriver
            ? {
                ...userData,
                drivers: items,
                geofences: []
              }
            : {
                ...userData,
                devices: items,
                geofences: []
              },
          cookie
        }, { withCredentials: true }).then(d => {
          reportData.push(...(userData.byDriver ? d.data[0].drivers : d.data[0].devices))
        })
        itemsCount = itemsCount + items.length
      } catch (e) {
        console.error(e)
      }
      console.log(`PROGRESS_PERC:${itemsCount / totalItems * 100}`)
    }))
  }

  if (userData.byDriver) {
    reportData.sort((a, b) => (a.driver.name > b.driver.name) ? 1 : -1)
  } else {
    reportData.sort((a, b) => (a.device.name > b.device.name) ? 1 : -1)
  }

  return reportData
}

exports.executeServerSide = executeServerSide
exports.getImgFromUrl = getImgFromUrl
exports.convertMS = convertMS
exports.coordsDistance = coordsDistance
exports.getDates = getDates
exports.convertToLocaleString = convertToLocaleString
exports.convertToLocaleDateString = convertToLocaleDateString
exports.convertToLocaleTimeString = convertToLocaleTimeString
exports.isClientSide = isClientSide
exports.getTimezoneOffset = getTimezoneOffset
exports.convertFromUTC = convertFromUTC
exports.weekDaySelected = weekDaySelected
exports.getLogo = (user) => {
  const host = window ? window.location.hostname : getUserPartner(user).host
  return getImage(getLogoUrl(host))
}
exports.convertToFeature = convertToFeature
exports.convertPositionToFeature = convertPositionToFeature
exports.calculateDistance = (positions, ignoreOdometer) => {
  let distanceValue = 0
  if (!ignoreOdometer && positions.length > 1 && positions[0].attributes.odometer && positions[positions.length - 1].attributes.odometer) {
    distanceValue = (positions[positions.length - 1].attributes.odometer - positions[0].attributes.odometer) / 1000
  }

  if (distanceValue > 0) {
    return distanceValue
  }

  return positions
    .sort((a, b) => new Date(a.fixTime).getTime() - new Date(b.fixTime).getTime())
    .map(p => [p.longitude, p.latitude])
    .reduce((previousValue, currentValue, currentIndex, array) => {
      return currentIndex < array.length - 1
        ? previousValue + distance.default(currentValue, array[currentIndex + 1])
        : previousValue
    }, 0) || 0
}

exports.sortPositions = (a, b) => new Date(a.fixTime).getTime() - new Date(b.fixTime).getTime()
exports.getLogoUrl = getLogoUrl
exports.convertFromUTCDate = (value, user) => {
  return convertFromUTC(value, user.attributes.timezone || getUserPartner(user).timezone)
}

exports.getCountry = position => position && position.address && position.address.split(',').slice(-1)[0].trim()

exports.processServerSide = (userData) => {
  const devices = devicesToProcess(userData)
  return devices.length > 100 && isClientSide()
}

const getServerHost = () => process.env.SERVER_HOST
exports.getServerHost = getServerHost
